import React from "react";
import "../Styles/Article1.css";
import img1 from "../Assets/A1.jpeg";
function Article1() {
  return (
    <div className="article1-cover">
      <div className="article1-main">
        <div className="article1">
          <div
            className="article1-img"
            data-aos="zoom"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
          >
            <img src={img1} alt="img1" />
          </div>
          <div className="article1-content">
            <h1
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Medical Billing & Coding In India
            </h1>
            <h2>Medical Coding and Billing Training in India</h2>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              A medical coding and billing specialist in India undergoes an
              intensive medical billing and coding program. This training
              ensures that Indian medical coding specialists possess the most up
              to date industry information and produce excellent quality results
              for overseas customers.
            </p>
            <br />
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              At Clinics4Health our medical coding specialists study topics like
              medical terminology, human anatomy, physiology, medical law,
              ethics (HIPAA), medical coding and medical billing. Our
              specialists are also trained in administrative topics such as
              computerized accounting basics, business communication,
              professional development and much more. This medical coding and
              billing training program is conducted for about 5 months.
            </p>
            <br />
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Clinics4Health specialists are then trained in evaluating and
              interpreting health records and reports in order to accurately
              code diagnoses and procedures according to recognized
              classification systems. This program also provides them with the
              basic skills and knowledge needed to submit medical claims for
              reimbursement, process bills, and operate medical office software.
            </p>
            <br />
            <h2
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              The Medical Coding and Billing Training Course at
            </h2>
            <br />
            <h3
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Clinics4Health
            </h3>
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              The medical billing course covers a wide range of topics in the
              medical industry. It is split into modules that deal with current
              practices, legal issues, documentation guidelines, history and
              much more.
            </p>
            <br />
            <h3
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Module I
            </h3>
            <h4
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Module 1 includes –
            </h4>
            <ul
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <li>Ethics in coding</li>
              <li>Medical terminology</li>
              <li>Pharmacology</li>
              <li>HCFA documentation guidelines</li>
              <li>Evaluation and management auditing</li>
            </ul>
            <h3
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Module II
            </h3>
            <h4
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Module 2 includes –
            </h4>
            <ol
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <li>Industry History & the Codes</li>
              <ul>
                <li>ICD Codes</li>
                <li>CPT Codes</li>
                <li>HCPCS Codes</li>
              </ul>
              <li>The Coder</li>
              <ul>
                <li>Private Physician Practice</li>
                <li>Hospital Services</li>
                <li>Background & Experience of the Coder</li>
              </ul>
              <li>ICD Coding</li>
              <p>
                Here specialists are taught about procedures like how reference
                books are used, coding guidelines, Outpatient & Physician Office
                Coding and much more.
              </p>
              <li>CPT Coding</li>
              <p>
                This section takes specialists right through all the guidelines
                for CPT coding from the evolution to a thorough understanding of
                symbols, modifiers, evaluation, management services and much
                more.
              </p>
              <li>Liability and Legal Issues</li>
              <p>
                In this section, the specialists are trained in the various
                liability and legal issues.
              </p>
            </ol>
            <h3
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Module III
            </h3>
            <h4
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Module 3 includes –
            </h4>
            <ul
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <li>The medical record as a source document</li>
              <li>Medical abbreviations</li>
              <li>Diagnostic and laboratory testing</li>
              <li>Inpatient reimbursement process</li>
            </ul>
            <h4
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Upon the completion of the Medical Coding and Billing Training
              program, Gaurdain Rcm‘s specialists are equipped to –
            </h4>
            <ul
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              <li>
                Read and interpret medical record documentation to identify
                codable diagnoses and procedures for data capture and billing.
              </li>
              <li>
                Accurately assign diagnostic and procedure codes for
                reimbursement and statistical purposes
              </li>
              <li>
                Apply knowledge of official coding guidelines to correctly
                sequence diagnostic and procedure codes
              </li>
              <li>
                Abstract information from patient records to complete insurance
                claims
              </li>
              <li>
                Gain knowledge of various reimbursement methodologies and fee
                schedules
              </li>
              <li>
                Link diagnostic codes to the proper procedure codes to ensure
                accurate claims submission
              </li>
              <li>
                Accurately assign diagnostic and procedure codes through the use
                of encoders and other computer software
              </li>
            </ul>
            <br />
            <h5>24 hours</h5>
            <h5>TAT</h5>
            <h5>98% Accuracy</h5>
            <h5>40% Cost Reduction</h5>
            <h5>500+ Customers</h5>
            <h5>07 years Experience</h5>
            <br />
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Customer-oriented healthcare outsourcing is our forte. Get in
              touch with us
            </p>
            <br />
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              This outline of the medical coding and billing training course
              gives an understanding of what medical specialists at Gaurdian Rcm
              are capable of handling. At Gaurdian Rcm, we ensure that medical
              billing and coding training is intensive so that our specialists
              are extremely proficient in delivering quality results.
            </p>
            <br />
            <p
              data-aos="zoom"
              data-aos-duration="500"
              data-aos-easing="ease-in-out"
            >
              Outsource medical billing and medical coding services to
              Clinics4Health and get access to proficient medical billing and
              coding services.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Article1;
